'use client'

import { Button } from '@acko/button'
import { Typography } from '@acko/typography'

export const CTASection = ({ onCheckPriceClick }: { onCheckPriceClick: () => void }) => (
  <section
    id="mobile-sticky-footer-stop"
    className="w-full py-40 lg:py-64 px-16 md:px-32 lg:px-[80px] bg-[var(--color-primary)]">
    <div className="max-w-[640px] flex flex-col gap-4 lg:gap-8 items-center text-center mx-auto">
      <Typography scale="4xl" emphasis="bold" as="h2" color="invert" className="text-balance !text-center">
        Buy Comprehensive Bike Insurance from ₹475
      </Typography>
      <Typography scale="base" color="invert" className="text-center! opacity-80 text-balance">
        Complete protection against accidents, theft & damage. <br />
        Zero commission. Instant policy in 60 seconds.
      </Typography>
      <div
        className="flex justify-center w-full lg:w-auto mt-16 bg-surface-base overflow-hidden rounded-full"
        style={{ backgroundColor: '#FFF' }}>
        <Button type="button" variant="secondary" size="lg" className="w-full lg:w-auto" onClick={onCheckPriceClick}>
          Get instant quote
        </Button>
      </div>
    </div>
  </section>
)
